import { type ValidationError } from '@adv-frontend/form-kit';

export const VALUE_IS_REQUIRED_CODE = 'VALUE_IS_REQUIRED';

export type ValueIsRequiredValidationError = ValidationError<typeof VALUE_IS_REQUIRED_CODE>;

export const VALUE_IS_REQUIRED_MESSAGE = 'Обязательное поле';
